import { render, staticRenderFns } from "./b-send-proposal.vue?vue&type=template&id=0fb4f415&"
import script from "./b-send-proposal.vue?vue&type=script&lang=js&"
export * from "./b-send-proposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports